<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <PinPad></PinPad>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import PinPad from '../components/PinPad.vue';
export default {
    name: 'HomeView',
    components: {
        ColumnaIzquierda,
        PinPad
    }
}
</script>